export interface Game {
  id: string;
  date: string;
  time: string;
  homeTeam: string;
  awayTeam: string;
  homeScore?: number;
  awayScore?: number;
  location?: string;
  locationId?: string;
  finished: boolean;
  live?: boolean;
  team?: string;
  pdfUrl?: string;
  refs?: string;
}

export interface Location {
  id: string;
  name: string;
  street: string;
  zip: string;
  city: string;
  glueAllowed?: boolean;
  glueInfo?: string;
}

export interface Standing {
  id: string;
  team: string;
  games: number;
  wins: number;
  draws: number;
  losses: number;
  goalsFor: number;
  goalsAgainst: number;
  goalDifference: number;
  points: number;
  position: number;
  totalGames?: number;
}

export interface Team {
  id: string;
  name: string;
  scheduleCollection: string;
  standingCollection: string;
}

export const TEAMS: Team[] = [
  {
    id: 'team-1F',
    name: 'Damen',
    scheduleCollection: 'league-OL_F_3',
    standingCollection: 'OL_F_3'
  },
  {
    id: 'team-1H',
    name: '1. Herren',
    scheduleCollection: 'league-OL_M_1',
    standingCollection: 'OL_M_1'
  },
  {
    id: 'team-2H',
    name: '2. Herren',
    scheduleCollection: 'league-ROL_M',
    standingCollection: 'ROL_M'
  },
  {
    id: 'team-3H',
    name: '3. Herren',
    scheduleCollection: 'league-RL_M',
    standingCollection: 'RL_M'
  }
];